import React from 'react'
import { useNavigationContext } from 'components/Utility/NavigationContext/NavigationContext'

export const PageNotFound: React.FC = () => {
  const navigationContext = useNavigationContext()
  navigationContext.status = 404
  return <div className={'page-not-found'}>
    <h1>
      404
    </h1>
    <div>
      Страница не найдена
    </div>
  </div>
}
